import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import FGInput from "../../../components/dumb/FGInput";
import usePageTitle from "../../../hooks/use-page-title";
import { HiArrowLeft, HiX } from "react-icons/hi";
import { ROUTES } from "../../../routes";
import Notifier from "../../../modules/notifier/notifier";
import { MdSave } from "react-icons/md";
import { useState, useContext } from "react";
import Multilingual from "../../../modules/multilingual/multilingual";
import { usePortalSettingSet } from "../../../context/portal-context";
import Debouncer from "../../../modules/debouncer/debouncer";
import Utils from "../../../utils/utils";
import FGTextarea from "../../../components/dumb/FGTextarea";
import ApiGroup from "../../../modules/api/group";
import AppUserContext from "../../../context/app-user-context";
import PagePortalNotFound from "../PagePortalNotFound/PagePortalNotFound";
import FooterBoxAction from "../../../components/common/FooterBoxAction";
import { BsBoxArrowInDown } from "react-icons/bs";

export default function PageGroupAdd() {
  const title = "Add New Group";
  const navigate = useNavigate();
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const location = useLocation();
  const { programmeId, cohortId } = useParams();
  const user = useContext(AppUserContext);
  const isValidProgrammeId = user.programmeIds.includes(programmeId);
  const [contentChanged, setContentChanged] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    cohortId: cohortId,
  });

  const handleOnChange = (e) => {
    setContentChanged(true);
    setFormData((d) => ({
      ...d,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Debouncer.execute("SUBMIT_DATA", async () => {
      setSending(true);
      const res = await ApiGroup.add(formData);

      if (res.status) {
        Notifier.success(res.message);
        await Utils.sleep(2000);
        setSending(false);
        navigate(`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`);
      } else {
        setSending(false);
        Notifier.error(res.message);
      }
    });
  };

  if (!isValidProgrammeId) {
    return <PagePortalNotFound />;
  }
  return (
    <main className="form-generic content-generic">
      <h1 className="fs-title hide-mobile-down">{title}</h1>

      {/* <div className="cg__actions hide-mobile-down">
        <Link
          to={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`}
          className="btn btn-primary"
          state={location.state}
          onClick={(e) => {
            if (
              contentChanged &&
              !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))
            ) {
              e.preventDefault();
            }
          }}
        >
          <HiArrowLeft /> Back
        </Link>
      </div> */}

      <form onSubmit={handleSubmit}>
        <FGInput
          name="name"
          id="name"
          type="text"
          label="Name"
          required
          autoFocus
          onChange={handleOnChange}
        />

        <FGTextarea
          name="description"
          id="description"
          label="Description"
          onChange={handleOnChange}
        />

        <div>
          <button type="submit" className="btn btn-secondary" disabled={sending}>
            <BsBoxArrowInDown className="icon-pos-upper" /> Save
          </button>{" "}
          <Link
            to={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`}
            className="btn btn-primary"
            state={location.state}
            onClick={(e) => {
              if (
                contentChanged &&
                !window.confirm(
                  Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE")
                )
              ) {
                e.preventDefault();
              }
            }}
          >
            <HiX /> Cancel
          </Link>
        </div>
      </form>

      <FooterBoxAction
        backUrl={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`}
        backUrlState={location.state}
        onBackUrlClick={(e) => {
          if (
            contentChanged &&
            !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))
          ) {
            e.preventDefault();
          }
        }}
      />
    </main>
  );
}
